export default __webpack_public_path__ + "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/mary-it-is-easy.png";